/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ parentPath: NonNullable<unknown>, folderName: NonNullable<unknown> }} Coinvestments_Dataroom_Folderpathjoin4Inputs */

const en_coinvestments_dataroom_folderpathjoin4 = /** @type {(inputs: Coinvestments_Dataroom_Folderpathjoin4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.parentPath} / ${i?.folderName}`)
};

/**
* | output |
* | --- |
* | "{parentPath} / {folderName}" |
*
* @param {Coinvestments_Dataroom_Folderpathjoin4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_folderpathjoin4 = /** @type {((inputs: Coinvestments_Dataroom_Folderpathjoin4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Folderpathjoin4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_folderpathjoin4(inputs)
});
export { coinvestments_dataroom_folderpathjoin4 as "coInvestments_dataRoom_folderPathJoin" }